/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Insert_Emotion_Tag_TitleInputs */



/**
* | output |
* | --- |
* | "Insert a delivery tag such as [laughs]. This voice performs tags instead of reading them aloud." |
*
* @param {Event_Ad_Insert_Emotion_Tag_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_insert_emotion_tag_title = /** @type {((inputs?: Event_Ad_Insert_Emotion_Tag_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Insert_Emotion_Tag_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérez une balise d'interprétation comme [laughs]. Cette voix interprète les balises au lieu de les lire.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einen Vortrags-Tag wie [laughs] einfügen. Diese Stimme setzt Tags um, statt sie vorzulesen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un tag di interpretazione come [laughs]. Questa voce interpreta i tag invece di leggerli.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте тег подачи, например [laughs]. Этот голос исполняет теги, а не зачитывает их.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inserta una etiqueta de interpretación como [laughs]. Esta voz interpreta las etiquetas en lugar de leerlas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入 [laughs] 等表演标签。此语音会演绎标签，而不是朗读出来。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("[laughs] などの演技タグを挿入します。この音声はタグを読み上げずに演技として反映します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("[laughs] जैसा अभिव्यक्ति टैग डालें। यह आवाज़ टैग को पढ़ने के बजाय उसे अभिनय में दिखाती है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira uma etiqueta de interpretação como [laughs]. Esta voz interpreta as etiquetas em vez de as ler.")
	return /** @type {LocalizedString} */ ("Insert a delivery tag such as [laughs]. This voice performs tags instead of reading them aloud.")
});